/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface NegozioPosDTO { 
    id?: string;
    nome?: string;
    indirizzo?: string;
    abilitato_ad_almeno_un_bando?: boolean;
}

